import { render, staticRenderFns } from "./TwoColumns.vue?vue&type=template&id=994001e4&"
import script from "./TwoColumns.vue?vue&type=script&lang=js&"
export * from "./TwoColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports